// extracted by mini-css-extract-plugin
export var closeButton = "_qh-2";
export var closeButtonIcon = "_qh-3";
export var lightboxContent = "_qh-1";
export var lightboxOverlay = "_qh-0";